// extracted by mini-css-extract-plugin
export default {"container":"HL7TemplateRulesPage_container__Sr407","field":"HL7TemplateRulesPage_field__Njnl8","table":"HL7TemplateRulesPage_table__mIxhv"};